var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:{ 'nav-open': _vm.$sidebar.showSidebar }},[(_vm.ribbonText)?_c('ribbon',{staticClass:"no-print",attrs:{"position":"right-bottom","fixed":true,"url":"","text":_vm.ribbonText,"color":"#F12510"}}):_vm._e(),_c('notifications'),_c('sidebar-fixed-toggle-button'),_c('side-bar',{staticClass:"no-print",attrs:{"background-color":_vm.sidebarBackground,"short-title":_vm.$t('sidebar.shortTitle'),"title":_vm.$t('sidebar.title'),"logo":_vm.brandedLogo,"maximised-sidebar":_vm.maximisedSidebar == 'true'},scopedSlots:_vm._u([{key:"links",fn:function(props){return [(_vm.$auth.can({statistics: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.dashboard'),
          icon: 'mdi mdi_icon mdi-24px mdi-view-dashboard-outline',
          path: '/dashboard'
        }}}):_vm._e(),(_vm.$auth.can({account: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.userSearch'),
          icon: 'mdi mdi_icon mdi-24px mdi-account-search-outline',
          path: '/account/search'
        }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.operatorReportsSubmenu'),
          icon: 'mdi mdi_icon mdi-24px mdi-bus',
        }}},[(_vm.$auth.can({operator_report: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.operatorTicketsReport'),
            path: '/operator-reports/tickets'
          }}}):_vm._e(),(_vm.$auth.can({operator_report: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.operatorJourneysCountReport'),
            path: '/operator-reports/journeys-count-report'
          }}}):_vm._e(),(_vm.$auth.can({operator_report: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.journeysStatsReports'),
            path: '/operator-reports/journeys-stats'
          }}}):_vm._e(),(_vm.$auth.can({operator_report: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.operatorRoutesStatsReport'),
            path: '/operator-reports/routes-stats'
          }}}):_vm._e()],1),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.reportsSubmenu'),
          icon: 'mdi mdi_icon mdi-24px mdi-file-chart-outline',
        }}},[(_vm.$auth.can({report: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.creditDebitReport'),
            path: '/reports/credit-debit'
          }}}):_vm._e(),(_vm.$auth.can({report: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.distributorsSummaryReport'),
            path: '/reports/distributors'
          }}}):_vm._e(),(_vm.$auth.can({report: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.soldSeasonTicketsReport'),
            path: '/reports/sold-season-tickets'
          }}}):_vm._e(),(_vm.$auth.can({report: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.canceledSeasonTicketsReport'),
            path: '/reports/canceled-season-tickets'
          }}}):_vm._e(),(_vm.$auth.can({report: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.seasonTicketsCountReport'),
            path: '/reports/season-tickets-count'
          }}}):_vm._e(),(_vm.$auth.can({inspection_locks_report: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.inspectionLocksReport'),
            path: '/reports/inspection-locks'
          }}}):_vm._e(),(_vm.$auth.can({journeys_by_stop_municipalities_report: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.journeysByStopMunicipalitiesReport'),
            path: '/reports/journeys-by-stop-municipalities'
          }}}):_vm._e(),(_vm.$auth.can({emv_taps_summary_report: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.emvTapsSummaryReport'),
            path: '/reports/emv-taps-summary-report'
          }}}):_vm._e(),(_vm.$auth.can({emv_success_payment_summary_report: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.emvSuccessPaymentsSummaryReport'),
            path: '/reports/emv-success-payments-summary-report'
          }}}):_vm._e()],1),(_vm.$auth.can({reporting_profile: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('sidebar.reportingProfiles'),
              icon: 'mdi mdi_icon mdi-24px mdi-file-table-box-outline',
              path: '/reports/reporting-profiles'
            }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.iam'),
          icon: 'mdi mdi_icon mdi-24px mdi-account-outline'
        }}},[(_vm.$auth.can({system_account: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.systemAccounts'),
            path: '/system/system-accounts'
          }}}):_vm._e(),(_vm.$auth.can({role: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.roles'),
            path: '/system/roles'
          }}}):_vm._e()],1),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.inspectors'),
          icon: 'mdi mdi_icon mdi-24px mdi-police-badge-outline',
        }}},[(_vm.$auth.can({inspector_team: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.inspector_teams'),
          path: '/system/inspector-teams'
        }}}):_vm._e(),(_vm.$auth.can({pt_lock: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.pt_locks'),
          path: '/system/pt-locks'
        }}}):_vm._e()],1),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.dataSubmenu'),
          icon: 'mdi mdi_icon mdi-24px mdi-database-search-outline'
        }}},[(_vm.$auth.can({money_claim: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.moneyClaims'),
          path: '/data/money-claims'
        }}}):_vm._e(),(_vm.$auth.can({account_deletions: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.accountDeletions'),
          path: '/data/account-deletions'
        }}}):_vm._e(),(_vm.$auth.can({top_up: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.topUp'),
          path: '/data/top-ups'
        }}}):_vm._e(),(_vm.$auth.can({pos_transaction: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.posTransactions'),
          path: '/data/pos-transactions'
        }}}):_vm._e(),(_vm.$auth.can({card_identity: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.cards'),
          path: '/data/cards'
        }}}):_vm._e(),(_vm.$auth.can({pt_schedule: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.ptSchedules'),
            path: '/data/pt-schedules',
          }}}):_vm._e(),(_vm.$auth.can({inspection_event: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.inspectionEvents'),
          path: '/data/inspection-events'
        }}}):_vm._e(),(_vm.$auth.can({emv_tap: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.emvTaps'),
          path: '/data/emv-taps'
        }}}):_vm._e(),(_vm.$auth.can({external_emv_tap: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.externalEmvTaps'),
          path: '/data/external-emv-taps'
        }}}):_vm._e(),(_vm.$auth.can({emv_clearing: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.emvClearings'),
          path: '/data/emv-clearings'
        }}}):_vm._e(),(_vm.$auth.can({emv_cut_over: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.emvCutOvers'),
          path: '/data/emv-cut-overs'
        }}}):_vm._e(),(_vm.$auth.can({audit_log: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.auditLogs'),
          path: '/data/audit-logs'
        }}}):_vm._e(),(_vm.$auth.can({email_message: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.emails'),
          path: '/data/emails'
        }}}):_vm._e(),(_vm.$auth.can({bloom_filters: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.offlineFilters'),
          path: '/data/offline-filters'
        }}}):_vm._e()],1),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.systemConfiguration'),
          icon: 'mdi mdi_icon mdi-24px mdi-wrench-outline'
        }}},[(_vm.$auth.can({fare_group: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.fareGroups'),
            path: '/config/fare-groups',
          }}}):_vm._e(),(_vm.$auth.can({operator: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.operators'),
            path: '/config/operators',
          }}}):_vm._e(),(_vm.$auth.can({discount: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.discounts'),
            path: '/config/discounts',
          }}}):_vm._e(),(_vm.$auth.can({pt_mapping: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.ptMappings'),
            path: '/config/pt-mappings',
          }}}):_vm._e(),(_vm.$auth.can({municipality: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.municipalities'),
            path: '/config/municipalities',
          }}}):_vm._e(),(_vm.$auth.can({bot_client: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.botClients'),
            path: '/config/bot-clients',
          }}}):_vm._e(),(_vm.$auth.can({pt_zone: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.ptZones'),
            path: '/config/pt-zones',
          }}}):_vm._e(),(_vm.$auth.can({pt_stop: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.ptStops'),
            path: '/config/pt-stops',
          }}}):_vm._e(),(_vm.$auth.can({notification_configuration: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.notificationConfigs'),
            path: '/config/notification-configs',
          }}}):_vm._e(),(_vm.$auth.can({email_template: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.emailTemplates'),
            path: '/config/email-templates',
          }}}):_vm._e(),(_vm.$auth.can({distributors: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.distributors'),
            path: '/config/distributors',
          }}}):_vm._e(),(_vm.$auth.can({season_tickets: 'read'}, 'permissions'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.seasonTickets'),
            path: '/config/season-tickets',
          }}}):_vm._e()],1)]}}])}),(_vm.ribbonText!=='')?_c('sidebar-share',{attrs:{"with-documentation":true,"background-color":_vm.sidebarBackground,"with-sidebar":true},on:{"update:backgroundColor":function($event){_vm.sidebarBackground=$event},"update:background-color":function($event){_vm.sidebarBackground=$event}}}):_vm._e(),_c('div',{staticClass:"main-panel",attrs:{"data":_vm.sidebarBackground}},[_c('dashboard-navbar'),_c('router-view',{attrs:{"name":"header"}}),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('div',{key:"_main"},[_c('router-view')],1)])],1),(!_vm.$route.meta.hideFooter && _vm.companyName)?_c('content-footer',{attrs:{"company-name":_vm.companyName,"company-url":_vm.companyUrl}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }